import {createPinia, PiniaVuePlugin, setActivePinia} from 'pinia';
import Vue from 'vue';


export function setupPinia () {
  const pinia = createPinia();
  Vue.use(PiniaVuePlugin);
  setActivePinia(pinia);
  return pinia;
}
